import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoMinusLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M8 17C7.44772 17 7 16.5523 7 16V14C7 13.4477 7.44772 13 8 13H22C22.5523 13 23 13.4477 23 14V16C23 16.5523 22.5523 17 22 17H8Z" })]
});
const ForwardRef = forwardRef(SvgIcoMinusLink);
export { ForwardRef as ReactComponent };
